import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import ComicDetailPage from "@/pages/comic/detail/page";
import ChapterReaderPage from "@/pages/comic/chapter/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:slug",
    element: <CategoryPage />,
  },
  {
    path: "/comic/:slug",
    element: <ComicDetailPage />,
  },
  {
    path: "/comic/:slug/chapter/:chapterId",
    element: <ChapterReaderPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;